<template>
  <v-dialog
    v-if="!$apollo.loading"
    v-model="reserveDialog"
    width="570"
    persistent
  >
    <v-card>
      <v-card-title
        class="header info"
        primary-title
      >
        <b>{{ $t('aff.reserveSlot') }}</b>
      </v-card-title>
      <v-card-text
        v-if="!_.isEmpty(refs)"
        class="data mt-5"
      >
        {{ $t('aff.reserveSlotDesc') }}
        <v-select
          v-model.trim="user_refid"
          style="margin: 20px 0 20px;"
          :items="refs"
          :item-text="'name'"
          :item-value="'refid'"
          :error-messages="UserErrors"
          :label="$t('aff.chooseUser')"
          dense
          @change="$v.user_refid.$touch()"
        />
      </v-card-text>
      <v-card-text
        v-else
        class="data mt-5"
      >
        <center>
          <b>{{ $t('aff.noRefs') }}</b>
        </center>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="reserveDialog = false"
        >
          {{ $t('globals.closeButton') }}
        </v-btn>
        <v-btn
          v-if="!_.isEmpty(refs)"
          color="primary"
          :disabled="loading"
          @click="reserveSlot()"
        >
          {{ $t('aff.reserveButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TREE_RESERVE_SLOT_MUTATION from "@/graphql/mutations/TreeReserveSlot.gql";
import AFF_REFERRALS_QUERY from "@/graphql/queries/AffReferrals.gql";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TreeReserveDialog",
  mixins: [validationMixin],
  props: {
    sponsor: {
      type: Object,
      default() {
        return {};
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      user_refid: null,
      refs: null,
      params: {
        fromDate: this.$moment()
          .subtract(180, "days")
          .format("YYYY-MM-DD HH:mm:ss"),
        toDate: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        page: 1,
        count: 500,
        filter: "NOT_ENROLLT"
      }
    };
  },
  validations: {
    user_refid: {
      required
    }
  },
  apollo: {
    affReferrals: {
      query: AFF_REFERRALS_QUERY,
      variables() {
        return this.params;
      },
      result(data) {
        if (data.loading == false) {
          this.refs = data.data.affReferrals.data;
        }
      }
    }
  },
  computed: {
    reserveDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$parent.reserveDialog = val;
      }
    },
    UserErrors() {
      const errors = [];
      if (!this.$v.user_refid.$dirty) return errors;
      !this.$v.user_refid.required && errors.push(this.$t("aff.reqField"));
      return errors;
    }
  },
  methods: {
    reserveSlot() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: TREE_RESERVE_SLOT_MUTATION,
          variables: {
            user_refid: this.user_refid,
            tree_sponsor_id: this.sponsor.id
          }
        })
        .then(data => {
          this.loading = false;
          this.$emit("updateLeaf");
          this.reserveDialog = false;
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.data {
  span {
    font-size: 12px;
    font-weight: 600;
    color: #7f97ab;
    text-transform: uppercase;
  }
  p {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  small {
    font-size: 13px;
    line-height: 16px;
    display: inline-block;
  }
}
</style>
